import React from "react";
import { useState, useEffect } from "react";
import { GitHub, Launch } from "@mui/icons-material";
import styled from "styled-components";
import "@fontsource/raleway";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Button,
} from "@mui/material";
import SpeedIcon from "@mui/icons-material/Speed";
import PhonelinkIcon from "@mui/icons-material/Phonelink";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import "@fontsource/great-vibes";
import TechStack from "./TechStack";

const Skill = () => {
  useEffect(() => {
    AOS.init({
      duration: 1800,
    });
    AOS.refresh();
  }, []);

  return (
    <div className="nav-link skills">
      <BOX id="skills">
        <Typography
          variant="h4"
          color="black"
          style={{
            fontFamily: "Great Vibes",
            color: "#1b242f",
            display: "inline-block",
            wordSpacing: 0,
          }}
          data-aos="fade-left"
        >
          Skills
        </Typography>
        <div
          style={{
            width: "3rem",
            backgroundColor: "#1b242f",
            height: "1vh",
            margin: "auto",
            marginBottom: "2%",
          }}
          data-aos="fade-left"
        ></div>
        <FR>
          <div className="hexaContainer">
            <div className="hex3" data-aos="flip-left">
              <SpeedIcon
                sx={{
                  width: "80%",
                  height: "70%",
                  color: "whitesmoke",
                }}
              />{" "}
            </div>{" "}
            <div className></div>
            <p
              style={{
                fontFamily: "Raleway",
                fontWeight: "bolder",
                fontSize: "1.15rem",
                color: "#1b242f",
              }}
            >
              Fast
            </p>
            <span style={{ fontFamily: "Raleway", fontSize: "0.7 rem" }}>
              Fast load times and lag free interaction
            </span>
          </div>
          <div className="hexaContainer">
            <div className="hex3" data-aos="flip-right">
              <PhonelinkIcon
                sx={{
                  width: "80%",
                  height: "70%",
                  color: "whitesmoke",
                }}
              />{" "}
            </div>
            <p
              style={{
                fontFamily: "Raleway",
                fontWeight: "bolder",
                fontSize: "1.15rem",
                color: "#1b242f",
              }}
            >
              Responsive
            </p>
            <span style={{ fontFamily: "Raleway", fontSize: "0.7 rem" }}>
              My layouts will work on any device, big or small.
            </span>
          </div>
          <div className="hexaContainer">
            <div className="hex3" data-aos="flip-left">
              {" "}
              <LightbulbIcon
                sx={{
                  width: "80%",
                  height: "70%",
                  color: "whitesmoke",
                }}
              />{" "}
            </div>
            <p
              style={{
                fontFamily: "Raleway",
                fontWeight: "bolder",
                fontSize: "1.15rem",
                color: "#1b242f",
              }}
            >
              Intutive
            </p>
            <span style={{ fontFamily: "Raleway", fontSize: "0.7 rem" }}>
              My layouts will work on any device, big or small.
            </span>
          </div>
          <div className="hexaContainer">
            <div className="hex3" data-aos="flip-right">
              <RocketLaunchIcon
                sx={{
                  width: "80%",
                  height: "70%",
                  color: "whitesmoke",
                }}
              />{" "}
            </div>
            <p
              style={{
                fontFamily: "Raleway",
                fontWeight: "bolder",
                fontSize: "1.15rem",
                color: "#1b242f",
              }}
            >
              Dynamic
            </p>
            <span style={{ fontFamily: "Raleway", fontSize: "0.7 rem" }}>
              Websites don't have to be static, I love making pages come to
              life.
            </span>
          </div>
        </FR>
        <TechStack />
      </BOX>
    </div>
  );
};

const FR = styled.div`
  display: flex;
  justify-content: space-between;

  box-sizing: border-box;
  .hexaContainer {
    display: flex;
    flex-direction: column;

    padding: 0.5em;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
`;

const BOX = styled.div`
  width: 100%;
  text-align: center;
  margin: auto;
  margin-bottom: 5%;
  width: 80%;

  .hex3 {
    height: 100px;
    width: 100px;
    margin: auto;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hex3 {
    background: #04c998;
    -webkit-clip-path: polygon(
      25% 5%,
      75% 5%,
      100% 50%,
      75% 95%,
      25% 95%,
      0% 50%
    );
    clip-path: polygon(25% 5%, 75% 5%, 100% 50%, 75% 95%, 25% 95%, 0% 50%);
  }

  @media screen and (max-width: 768px) {
    width: 90%;
  }
`;
export default Skill;
